import React, { Component } from 'react';
import './ErrorScreen.css';

class ErrorScreen extends Component {
	componentDidMount() {
		window.document.title = 'Error | Imagine Learning';
	}

	getErrorString(error) {
		if (!error) {
			return '';
		}
		if (error instanceof Error) {
			const errorObj = Object.getOwnPropertyNames(error).reduce(
				(accumulator, prop) => ({ ...accumulator, [prop]: error[prop] }),
				{}
			);
			return JSON.stringify(errorObj, null, '  ');
		}
		if (typeof error === 'object') {
			return JSON.stringify(error, null, '  ');
		}
		return error.toString();
	}

	render() {
		const error = this.getErrorString(this.props.error);
		const errorDetails = error ? (
			<div>
				<h2>Error Details</h2>
				<pre className="details">{error}</pre>
			</div>
		) : null;

		return (
			<div className="ErrorScreen row">
				<div className="small-10 medium-8 small-centered">
					<div className="callout row">
						<div className="columns">
							<h1>Error</h1>
							<p>
								An error has occurred. If you experience this problem again, contact Imagine Learning Customer Support
								at 1-866-457-8776 or visit{' '}
								<a href="https://help.imaginelearning.com" rel="noopener noreferrer" target="_blank">
									help.imaginelearning.com
								</a>.
							</p>
							{errorDetails}
						</div>
					</div>
				</div>
				<div className="footer" />
			</div>
		);
	}
}

export default ErrorScreen;



// WEBPACK FOOTER //
// ./src/components/ErrorScreen/ErrorScreen.js